<pds-modal #modal title="Remover Pedido de Compra" [width]="520" (dismiss)="onDismiss()">
  <main class="modal__content">
    <form [formGroup]="form">
      <pds-form-field label="Justificativa">
        <select formControlName="reason" required id="reason">
          <option value="" disabled selected>Selecione uma justificativa</option>
          @for (reason of reasonRemoveOrderValue; track $index) { @if (reason !== reasonRemoveOrder.PRIOR_TO_DEMAND) {
          <option [value]="reason">{{ reason | reasonRemoverOrder }}</option>
          } }
        </select>
      </pds-form-field>
    </form>
    <p>
      Você está removendo o pedido de compra <b>{{ commerceReference() }}</b> da listagem atual, mas ele continuará disponível em Compras.
    </p>
    <p>Esta ação não poderá ser desfeita. Deseja continuar?</p>
    <pds-form-actions>
      <button pdsButton (click)="onClickConfirm(orderId(), formValue.reason)" type="button">Confirmar</button>
    </pds-form-actions>
  </main>
</pds-modal>
